
import React from 'react';

import { Link, useNavigate } from "react-router-dom";

import {
    Grid, AppBar, Toolbar, Menu,
    MenuItem,
    Avatar,
    Divider, Button,
    DrawerHeader,
    ListItem,
    ListItemButton,
    ListItemIcon,
    IconButton,
    ListItemText,
    List,
    Typography,
    ListItemAvatar
} from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import { styled, useTheme } from '@mui/material/styles';

import Widgets from '@mui/icons-material/WidgetsOutlined';
// import Icon from '@mui/icons-material/Logout';
import CloseIcon from '@mui/icons-material/Close';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import rocket from "./assets/rocket.svg";
import faq from "./assets/faq.svg";
import home from "./assets/home.svg";
import service from "./assets/service.svg";
import ticket from "./assets/ticket.svg";
import logout from "./assets/logout.svg";
import logo from "./assets/logo.png";


const drawerWidth = 270;
const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(10)} + 1px)`,
    // [theme.breakpoints.up('sm')]: {
    //     width: `calc(${theme.spacing(8)} + 1px)`,
    // },
});
const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);


export default function MatSidebar(props) {
    const { window } = props;

    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const [open, setOpen] = React.useState(false);
    const container = window !== undefined ? () => window().document.body : undefined;

    const drawer = (
        <>
            <List sx={mobileOpen && { pt: 0 }}>
                <ListItem key={0} sx={{ color: '#fff', mt: 0, mx: 'auto', pl: 2.5 }} component='a' target="_blank" href='/'>
                    <ListItemAvatar>
                        <Avatar imgProps={{ sx: { objectFit: "contain" } }} sx={{ width: '42px', height: 'unset' }} variant="square"
                            src={logo} />
                    </ListItemAvatar>
                    <ListItemText sx={{
                        '& *': {
                            color: '#fff'
                        },
                        pl: 1.2
                    }} primaryTypographyProps={{
                        sx: {
                            fontSize: '16px'
                        }
                    }} primary='Hamyarma' secondary="Digital Creative Agency" />
                </ListItem>
                {[
                    ['حساب کاربری', '/support', home, true],
                    ...(!props.user?.has_plan ? [['پلن های پشتیبانی', '/support/plans', rocket]] : []),
                    ['تیکت های من', '/support/tickets', ticket],
                    ['خدمات', '/support/service', service, true],
                    ['سوالات متداول', '/support/faq', faq, true],
                    ['خروج', '/accounts/logout', logout, false, true],
                ].map(([text, link, icon = null, isDivider = false, isHref = false], index) => (
                    <>
                        <ListItem key={index + 1} disablePadding sx={{ display: 'block', color: '#fff', my: 1 }}>
                            <ListItemButton onClick={handleDrawerToggle}
                                component={isHref ? 'a' : Link} href={isHref && link} to={link}
                                sx={{
                                    // justifyContent: open ? 'initial' : 'center',
                                    // px: 2.5,
                                    pl: 1.5
                                }}
                            >
                                <ListItemAvatar>
                                    <Avatar imgProps={{ sx: { objectFit: "contain" } }} sx={{ width: '24px', height: '24px', margin: '0 auto' }} variant="rounded" src={icon} />
                                </ListItemAvatar>

                                {(open || mobileOpen) && (
                                    <ListItemText sx={{ ml: 2 }} primaryTypographyProps={{ sx: { fontSize: '14px' } }} primary={text} />
                                )}
                            </ListItemButton>
                        </ListItem>
                        {isDivider && <Divider sx={{ borderColor: '#ffffff5e' }} variant="middle" />}
                    </>
                ))}
                {/* <Button variant="outlined" component={Link} to="/support/tickets" sx={{ ml: 2 }} color="secondary" >تیکت ها</Button>
                    { && (
                        <Button variant="outlined" component={Link} to="/support/plans" sx={{ ml: 2 }} color="secondary" > </Button>
                    )}
                    <Button variant="outlined" component={Link} to="/support/service" sx={{ ml: 2 }} color="secondary" >خدمات</Button> */}
            </List>
        </>
    )

    return (
        <>
            <IconButton
                // color="inherit"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{
                    mr: 2, display: { sm: 'none' },
                    position: 'fixed',
                    top: '12px',
                    left: '16px',
                    zIndex: '1101',
                }}
            >
                <Widgets sx={{ width: '24px', height: '24px' }} weight={200} />
            </IconButton>
            <MuiDrawer
                container={container}
                dir="ltr"
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                className="ltr"
                ModalProps={{
                    keepMounted: true,
                }}
                anchor="right"
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': { background: '#02192d', boxSizing: 'border-box', width: drawerWidth, left: 0 },
                }}
            >
                <IconButton
                    variation="contained"
                    // edge="start"
                    onClick={handleDrawerToggle}
                    sx={{
                        mr: 2,
                        ml: 'auto',
                        mt: 1.5,
                        width: 'fit-content',
                        backgroundColor: '#082e4e !important',
                        color: '#fff',
                        borderRadius: '4px',
                        position: 'absolute',
                        right: '-6px',
                        px: .5,
                        py: '1px',
                        zIndex: '99999'
                    }} >
                    <CloseIcon sx={{ width: '12px' }} />
                </IconButton>
                {drawer}
            </MuiDrawer>

            <Drawer sx={{
                '& .MuiDrawer-paper': { background: '#02192d' },
                display: { xs: 'none', sm: 'block' },
            }}
                variant="permanent" onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)} open={open}>
                {drawer}
            </Drawer>
        </>
    )
}
